'use strict';

import navbar from '../components/layout/navbar/i18n/en-CA';

import toolbox from '../pages/registrations/admin/components/toolbox/i18n/en-CA';
import searchInputTranslation from '../components/library/inputs/search/i18n/en-CA';
import headerTranslation from '../components/layout/header/i18n/en-CA';
import userMenu from '../components/layout/header/userMenu/i18n/en-CA';
import organizationMenu from '../components/layout/navbar/organizationMenu/i18n/en-CA';
import errorTranslation from '../components/errors/i18n/en-CA';
import modalComponent from '../components/modal/i18n/en-CA';
import publicControls from '../components/form/public/controls/i18n/en-CA';
import inputs from '../components/library/inputs/i18n/en-CA';
import formPublic from '../components/form/public/i18n/en-CA';
import fields from '../components/form/public/utilities/i18n/en-CA';
import slices from '../slices/i18n/fr-CA';

/* Pages */
import formList from '../pages/registrations/i18n/en-CA';
import formSettings from '../pages/registrations/admin/components/formSettings/i18n/en-CA';
import rules from '../pages/registrations/admin/components/rules/i18n/en-CA';
import adminProperties from '../pages/registrations/admin/components/properties/i18n/en-CA';
import optionsWrapper from '../pages/registrations/admin/components/form/utilities/i18n/en-CA';
import formAdmin from '../pages/registrations/admin/components/i18n/en-CA';
import loginPage from '../pages/login/i18n/en-CA';
import formConfirmPage from '../pages/registrations/confirm/i18n/en-CA';
import organizationPage from '../pages/organization/i18n/en-CA';
import reports from '../pages/reports/i18n/en-CA';
import paymentAccountsPage from '../pages/paymentAccounts/i18n/en-CA';
import paymentModes from '../pages/registrations/admin/components/paymentModes/i18n/en-CA';
import discountCodes from '../pages/registrations/admin/components/discountCodes/i18n/en-CA';
import userList from '../pages/users/i18n/en-CA';
import notificationList from '../pages/notifications/i18n/en-CA';

export default {
  cancel: 'Cancel',
  delete: 'Delete',
  save: 'Save',
  confirm: 'Confirm',
  add: 'Add',
  french: 'French',
  english: 'English',
  ...navbar,
  ...toolbox,
  ...searchInputTranslation,
  ...headerTranslation,
  ...userMenu,
  ...organizationMenu,
  ...errorTranslation,
  ...formList,
  ...rules,
  ...publicControls,
  ...formSettings,
  ...modalComponent,
  ...inputs,
  ...adminProperties,
  ...optionsWrapper,
  ...formAdmin,
  ...loginPage,
  ...formPublic,
  ...formConfirmPage,
  ...organizationPage,
  ...reports,
  ...paymentAccountsPage,
  ...slices,
  ...fields,
  ...paymentModes,
  ...discountCodes,
  ...userList,
  ...notificationList,
};
